export interface Slide {
  backgroundImage: string;
  label: string;
  logo: string;
  logoAlt: string;
}

export const events = {
  SPLASH_BANNER_CLICK: 'splash_banner_click',
} as const;
